/** In-pane placeholder while a code-split chunk or first fetch is out. */
export function PaneLoading({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex h-full min-h-[6rem] items-center justify-center px-3 text-xs text-ink-faint">
      {label}
    </div>
  );
}
